<script lang="ts" setup>
import VbNewButton from "@/components/crud/VbNewButton.vue"
import { injectMandatory, type ModuleConfiguration, useInlineTable } from "@/vf"

const config = injectMandatory<ModuleConfiguration>(
    "module-config",
    "ScListToolbar must be used inside an element that provides module-config like VfEdit or VfShow.",
)
const inlineTable = useInlineTable()
</script>

<template>
    <VbNewButton
        v-if="config.list.newButton()"
        class="card-toolbar__item"
        :class="{
            'card-toolbar__item--open': inlineTable?.rowIsOpen('new'),
        }"
    ></VbNewButton>
</template>
